import {patientService} from "../../services/medicationmanagement/patientApi/PatientApi";
import {Patient} from "../../services/medicationmanagement/patientApi/models/Patient";
import { resetDraftPerformedOn } from "../resident-medications/resetDraftPerformedOn";

export type PharmacyResidentMedicationDetail = Patient;
export const getResidentMedicationDetailAndResetDraft=async (authoringSystem:string,authoringSystemForeignKey:string)=>{
    let patientInfo=await patientService.getPatient(authoringSystem,authoringSystemForeignKey);
    await resetDraftPerformedOn(authoringSystem,authoringSystemForeignKey,patientInfo?.isOnboarding);
    
    return {
        ...patientInfo
    } as PharmacyResidentMedicationDetail;
}